import { render, staticRenderFns } from "./LearningNew.vue?vue&type=template&id=67b75707&scoped=true&"
import script from "./LearningNew.vue?vue&type=script&lang=js&"
export * from "./LearningNew.vue?vue&type=script&lang=js&"
import style0 from "./LearningNew.vue?vue&type=style&index=0&id=67b75707&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b75707",
  null
  
)

export default component.exports